module.exports = __webpack_public_path__ + "img/login.896b5c4a.png";